<template>
  <div class="shipping">
    <v-countdown v-if="count_down" :count_down="count_down" position="checkout" no_reset="no_reset"></v-countdown>
    <v-shippingform :user="user" :cart="cart" :service="myService"></v-shippingform>
    <div class="shippingmethod">
      <h4>{{$t('shopping.shipping_method')}}</h4>
      <div class="method" v-if="shipping_list.length">
          <label v-for="item in shipping_list" :key="item.id" :for="item.id">
            <input
              name="shipping_method"
              type="radio"
              v-model="shipping_method"
              @change="change_shipping_method(item.cost)"
              :value="item.id"
              :id="item.id"
            />
            <div :class="shipping_method==item.id?'checked dot':'dot'"></div>
            <i v-html="item.label"></i>
            <span><v-currencysymbol></v-currencysymbol>{{item.cost.toFixed(2)}}</span>
          </label>
      </div>
      <v-noavailable v-else :message="$t('shopping.no_shipping')"></v-noavailable>
      <div class="shipping_insurance" v-if="shipping_insurance">
        <el-checkbox v-model="shipping_insurance_off">
          {{$t('shopping.add_shipping_insurance_to_your_order')}} <v-currencysymbol></v-currencysymbol>{{(this.shipping_insurance_price-0).toFixed(2)}}
          <el-tooltip class="item" effect="dark" placement="top">
            <div
              slot="content"
              class="text-center"
              style="width:302px;fontSize:14px;color:#eee;"
            >{{$t('shopping.shipping_insurance_offers')}}</div>
            <span class="phonetitle iconfont icon-wenhao1"></span>
          </el-tooltip>
        </el-checkbox>
      </div>
      <v-addressformfoot
        :toNext="$t('shopping.continue_to_payment')"
        toPrev="information"
        :nothing="nothing"
        ref="addressformfoot"
        @toNextApi="topayment"
      ></v-addressformfoot>
    </div>
    <v-checkoutcommonfoot :blogname="blogname"></v-checkoutcommonfoot>
  </div>
</template>
<script>
import API from "../../../API.js";
import vShippingform from "./shippingform";
import vCheckoutcommonfoot from "./checkoutcommonfoot";
import CountryStateJson from "../../../../assets/country_state.json";
import * as Sentry from "@sentry/browser";
export default {
  props: [
    "user",
    "cart",
    "service",
    "blogname",
    "count_down",
    "shipping_insurance",
  ],
  data() {
    return {
      myService:[],
      shipping_method: "",
      nothing: false,
      shipping_insurance_off: "",
      shipping_insurance_price: 0, //运费险价格
      cart_hash:window.location.pathname.split('/')[2],
      utm_medium:null,
      shipping_list:[]
    };
  },
  beforeMount(){
    if(this.cart.shipping&&this.cart.shipping.methods&&this.cart.shipping.methods.length>0){
        this.shipping_list=this.cart.shipping.methods;
        this.shipping_list.sort(function(a, b){return a.cost - b.cost});
        this.shipping_list.pop();
    }
    this.myService=this.concatCounty(this.service,CountryStateJson);
  },
  methods: {
    change_shipping_method(price) {
      this.$store.dispatch("change_order_shipping", price);
    },
    async topayment() {
      try {
        if (!this.shipping_method) {
          this.$message.error("Please select Shipping method");
        } else {
          this.$refs.addressformfoot.active = true;
          this.utm_medium=this.getSearch('utm_medium');
          let shipping_data={
            cart_hash:this.cart_hash,
            shipping_method: this.shipping_method,
            shipping_insurance: this.shipping_insurance_off,
          };
          if(this.utm_medium){
            shipping_data.utm_medium=this.utm_medium;
          }
          let res = await this.$axios.post(API.shipping_method,shipping_data);
          if (window.gtag) {
            window.gtag("event", "set_shipping", {
            'event_category': 'ecommerce'
            });
          }
          setTimeout(() => {
            this.$refs.addressformfoot.active = false;
          }, 5000);
          window.open(this.replaceSearch('step','payment_method'), "_self");
        }
      } catch (error) {
        this.$refs.addressformfoot.active = false;
        if (error.response.status == 422) {
          this.$message.error("Please select Shipping method");
        } else {
          this.$message.error(error.response.data.message);
        }
        // Sentry.captureException(error.response);
      }
    },
  },
  mounted() {
    // window.addEventListener(
    //   "pageshow",
    //   () => {
    //     this.$refs.addressformfoot.active = false;
    //   },
    //   false
    // );
    console.log("shipping_insurance", this.shipping_insurance);
    console.log(this.cart);
    // 如果没有定义过运费险则默认开启。
    if (this.cart.shipping_insurance == undefined) {
      this.shipping_insurance_off = true;
    } else {
      // 若定义为则以定义过的为准
      this.shipping_insurance_off = this.cart.shipping_insurance;
    }
    // 运费险价格
    this.shipping_insurance_price =
      this.shipping_insurance * this.cart.cart_subtotal;
    this.$store.dispatch(
      "change_shipping_insurance_price",
      this.shipping_insurance_price
    );

    if (this.cart.shipping.methods.length) {
      this.shipping_method = this.cart.shipping.chosen_method;
      let shipping_chosen_method = sessionStorage.getItem(
        "shipping_chosen_method"
      );
      if (window.performance.navigation.type == 2 && shipping_chosen_method) {
        this.shipping_method = shipping_chosen_method;
      }
      let res = this.cart.shipping.methods.some((item) => {
        if (item.id == this.shipping_method) {
          this.$store.dispatch("change_order_shipping", item.cost);
          return true;
        }
      });
      if (!res) {
        this.shipping_method = this.shipping_list[0].id;
        this.$store.dispatch(
          "change_order_shipping",
          this.shipping_list[0].cost
        );
      }
    } else {
      // 没有任何配送方式禁止通过按钮点击到下一步。
      this.nothing = true;
    }
  },
  watch: {
    shipping_method(){
      sessionStorage.setItem("shipping_chosen_method",this.shipping_method);
    },
    shipping_insurance_off() {
      if (this.shipping_insurance_off) {
        this.$store.dispatch(
          "change_shipping_insurance_price",
          this.shipping_insurance_price - 0
        );
      } else {
        this.$store.dispatch("change_shipping_insurance_price", 0);
      }
    },
  },
  components: {
    vShippingform,
    vCheckoutcommonfoot,
  },
};
</script>
<style  lang='scss'>
.shipping {
  .shippingmethod {
    padding-top: 42px;

    h4 {
      font-size: 18px;
      color: #333;
    }

    .method {
      border: 1px solid #d9d9d9;
      border-radius: 5px;

      label {
        width: 100%;
        cursor: pointer;
        font-size: 14px;
        margin: 0;
        padding: 16px;

        input {
          display: none;
        }

        .checked {
          background: #0f88a7 !important;
        }

        .dot {
          display: inline-block;
          width: 18px;
          height: 18px;
          line-height: 18px;
          border-radius: 50%;
          margin-right: 10.5px;
          text-align: center;
          background: white;
          border: 1px solid #d9d9d9;

          &:after {
            content: "";
            vertical-align: middle;
            display: inline-block;
            margin-top: -5px;
            width: 5px;
            height: 5px;
            background: white;
            border-radius: 50%;
          }
        }

        & > i {
          color: #545454;
        }

        & > span {
          color: #333;
          float: right;
        }
      }

      label:not(:first-child) {
        border-top: 1px solid #d9d9d9;
      }

    }
    .shipping_insurance {
      margin: 12px 16px;
      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 18px;
            height: 18px;
            border-color: #d9d9d9;
            &::after {
              height: 11px;
              left: 6px;
            }
          }
        }
        .el-checkbox__label {
          color: #737373;
          white-space: normal !important;
          vertical-align: middle !important;
        }
        .is-checked {
          .el-checkbox__inner {
            background-color: #0f88a7;
            border-color: #0f88a7;
          }
        }
      }
    }

    .addressfoot {
      margin-top: 15px;

      button {
        font-size: 14px;
        padding: 20px 24px;
        width: 100%;
        border: none;
        background: #0f88a7;
        color: white;
        border-radius: 5px;
      }

      .disablebutton {
        opacity: 0.5;
      }

      a {
        height: 61px;
        text-decoration: none;
        color: #0f88a7;
        font-size: 14px;
      }
    }
  }
}

* {
  font-style: normal;
}
</style>
